import type { TeamListQuery } from "@bezoned/shared/types/api/team/team-list.types.js";
import { status } from "http-status";

import { ApiResponseError, teamsGet } from "../../../services/api.service.js";

const MAX_RETRIES = 3;

export const getTeamsGetQueryKey = (query: TeamListQuery = {}) =>
  ["teamsGet", query] as const;

export const getTeamsGetQueryOptions = (query: TeamListQuery = {}) => ({
  queryFn: () => teamsGet(query),
  queryKey: getTeamsGetQueryKey(query),
  retry: (failureCount: number, error: Error) =>
    failureCount < MAX_RETRIES &&
    !(
      error instanceof ApiResponseError &&
      error.status === status.INTERNAL_SERVER_ERROR
    ),
});
